module.exports = __webpack_public_path__ + "img/brushes-jp-hero.65b80a0.jpg";